module.exports = __webpack_public_path__ + "badge-contenido.svg?485ee53a1c027a50d7e1443e69ec720f";


//////////////////
// WEBPACK FOOTER
// ./public/images/site/badge-contenido.svg
// module id = 480
// module chunks = 0